import React, { useState } from "react";
import axios from "axios";
import { CheckCircle2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const field = {
  width: "100%", boxSizing: "border-box", background: "transparent",
  border: "1px solid var(--ang-gold)", borderRadius: 8, padding: "11px 12px",
  fontFamily: "Manrope", fontSize: 14, color: "var(--ang-text)", marginTop: 6,
};
const label = { fontFamily: "Manrope", fontSize: 12, color: "var(--ang-text)", opacity: 0.7 };

/** Публичная заявка на удаление аккаунта — требование Google Play. */
export function DeleteAccountForm() {
  const [form, setForm] = useState({ phone: "", name: "", email: "", comment: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending"); setError("");
    try {
      await axios.post(`${API}/public/account-deletion-request`, form);
      setState("done");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Не удалось отправить заявку, попробуйте позже");
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <div data-testid="delete-account-success"
        style={{ marginTop: 26, display: "flex", gap: 10, alignItems: "flex-start",
          border: "1px solid var(--ang-gold)", borderRadius: 10, padding: 16 }}>
        <CheckCircle2 size={20} style={{ color: "var(--ang-gold-strong)", flexShrink: 0 }} />
        <div style={{ fontFamily: "Manrope", fontSize: 13.5, lineHeight: 1.6 }}>
          Заявка принята. Мы свяжемся с вами по указанному номеру для подтверждения
          и удалим аккаунт в течение 14 календарных дней.
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="delete-account-form" style={{ marginTop: 26 }}>
      <h2 style={{ fontFamily: "Manrope", fontSize: 15, fontWeight: 700, letterSpacing: "0.04em",
        textTransform: "uppercase", color: "var(--ang-text)", opacity: 0.75, margin: "0 0 10px" }}>
        Отправить заявку на удаление
      </h2>
      <label style={label}>Номер телефона аккаунта *
        <input required type="tel" value={form.phone} data-testid="delete-account-phone"
          placeholder="+7 7XX XXX XX XX" style={field}
          onChange={(e) => setForm({ ...form, phone: e.target.value })} />
      </label>
      <label style={{ ...label, display: "block", marginTop: 14 }}>Имя
        <input value={form.name} data-testid="delete-account-name" style={field}
          onChange={(e) => setForm({ ...form, name: e.target.value })} />
      </label>
      <label style={{ ...label, display: "block", marginTop: 14 }}>Email для ответа
        <input type="email" value={form.email} data-testid="delete-account-email" style={field}
          onChange={(e) => setForm({ ...form, email: e.target.value })} />
      </label>
      <label style={{ ...label, display: "block", marginTop: 14 }}>Комментарий
        <textarea rows={3} value={form.comment} data-testid="delete-account-comment"
          style={{ ...field, resize: "vertical" }}
          onChange={(e) => setForm({ ...form, comment: e.target.value })} />
      </label>
      {error && <div data-testid="delete-account-error"
        style={{ color: "#dc2626", fontFamily: "Manrope", fontSize: 12.5, marginTop: 10 }}>{error}</div>}
      <button type="submit" disabled={state === "sending"} data-testid="delete-account-submit"
        style={{ marginTop: 18, background: "var(--ang-gold)", color: "#1A1A1A", border: "none",
          borderRadius: 999, padding: "12px 24px", fontFamily: "Manrope", fontSize: 13,
          fontWeight: 800, letterSpacing: "0.04em", textTransform: "uppercase",
          cursor: state === "sending" ? "default" : "pointer" }}>
        {state === "sending" ? "Отправляем…" : "Отправить заявку"}
      </button>
    </form>
  );
}

export default DeleteAccountForm;
